import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateLoadComponent } from './create-load/create-load.component';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { CancelCreateLoadDialogComponent } from './cancel-create-load-dialog/cancel-create-load-dialog.component';
import { MatCardModule } from '@angular/material/card';
import { SharedUiFleetoperateToolbarModule } from '@fleetoperate/shared/ui/fleetoperate-toolbar';
import { SharedUiHeaderModule } from '@fleetoperate/shared/ui/header';
import { SharedUiErrorMessageModule } from '@fleetoperate/shared/ui/error-message';
import { TimeMaskModule, GoogleAddressAutocompleteModule } from '@fleetoperate/shared/util';
import { PhoneMaskModule } from '@fleetoperate/shared/util';
@NgModule({
  declarations: [CreateLoadComponent, CancelCreateLoadDialogComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatCardModule,
    GoogleAddressAutocompleteModule,
    SharedUiFleetoperateToolbarModule,
    SharedUiHeaderModule,
    SharedUiErrorMessageModule,
    TimeMaskModule,
    PhoneMaskModule
  ],
  entryComponents: [CancelCreateLoadDialogComponent]
})
export class CreateLoadModule {}

export { CreateLoadComponent } from './create-load/create-load.component';
